import Category from "./Category";
import Customer from "./Customer";
import Department from "./Department";
import FetchMeta from "./FetchMeta";
import InventoryMovement from "./InventoryMovement";
import InvoiceSequence from "./InvoiceSequence";
import Layout from "./Layout";
import LayoutNode from "./LayoutNode";
import Location from "./Location";
import PaymentMethod from "./PaymentMethod";
import PayType from "./PayType";
import Product from "./Product";
import ReceiptTemplate from "./ReceiptTemplate";
import ReceiptTemplateType from "./ReceiptTemplateType";
import Sale from "./Sale";
import SaleItem from "./SaleItem";
import Staff from "./Staff";
import Terminal from "./Terminal";
import InventoryMovementItem from "./InventoryMovementItem";
import Count from "./Count";
import SerialNumber from "./SerialNumber";
import Supplier from "./Supplier";
import TaxGroup from "./TaxGroup";
import StockCount from "./StockCount";
import StockCountLine from "./StockCountLine";
import StockCountItem from "./StockCountItem";
import RetailerPayType from "./RetailerPayType";
import DocketTemplateType from "./DocketTemplateType";
import DocketTemplate from "./DocketTemplate";
import ProductKit from "./ProductKit";
import ProductKitItem from "./ProductKitItem";

export const allModels = [
  Category,
  Department,
  FetchMeta,
  Product,
  ProductKit,
  ProductKitItem,
  Layout,
  LayoutNode,
  Location,
  Staff,
  Terminal,
  Sale,
  SaleItem,
  PayType,
  PaymentMethod,
  Customer,
  Supplier,
  InvoiceSequence,
  ReceiptTemplateType,
  ReceiptTemplate,
  SerialNumber,
  InventoryMovement,
  InventoryMovementItem,
  Count,
  TaxGroup,
  StockCount,
  StockCountLine,
  StockCountItem,
  RetailerPayType,
  DocketTemplateType,
  DocketTemplate,
];
